import { AutoAwesome } from '@mui/icons-material';
import { alpha, Stack, Text } from '@ltvco/refresh-lib/theme';
import { Answer } from 'api/requests/communityBuzz/interfaces';
import { isBumperAIContributor } from 'components/CommunityBuzz/constants';
import { calculateTimeSince } from './utils';
import { BUMPER_AI_COLOR, BUMPER_AI_USERNAME } from '../constants';

interface AnswerDetailsProps {
  answer?: Answer;
}

export const AnswerDetails = ({ answer }: AnswerDetailsProps) => {
  const isBumperAI = isBumperAIContributor(answer?.source, answer?.username);

  return (
    <Stack
      width="100%"
      mb={2}
      p={2}
      sx={(theme) => ({
        backgroundColor: isBumperAI
          ? alpha(BUMPER_AI_COLOR, 0.035)
          : 'transparent',
        borderBottom: `1px solid ${theme.palette.divider}`,
      })}
    >
      <Stack width="100%" spacing={1}>
        <Stack alignItems="center" direction="row" spacing={1}>
          {isBumperAI && <AutoAwesome sx={{ color: BUMPER_AI_COLOR }} />}
          <Text variant="h5">
            {isBumperAI ? BUMPER_AI_USERNAME : answer?.username}
          </Text>
          <Text variant="body2" color="text.secondary">
            {calculateTimeSince(answer?.created_at)}
          </Text>
        </Stack>
        <Text variant="body2" mb={0}>
          {answer?.body_md}
        </Text>
      </Stack>
    </Stack>
  );
};
